var module = angular.module('octopusApp.configuration');

module.controller('SubscriptionsController', function($scope, $location, busy, octopusRepository, octopusClient, octopusPermissionSet) {
    var isLoading = $scope.isLoading = busy.create();

    function parseTimeSpan(timeSpan)
    {
        var days = 0;
        var hours = 0;
        var mins = 0;

        if (timeSpan) {
            var timeSpanParts = timeSpan.split(":");
            var tsPart1 = timeSpanParts[0];
            if (tsPart1.indexOf(".") !== -1) {
                // days included
                var daysAndHours = tsPart1.split(".");
                days = parseInt(daysAndHours[0]);
                hours = parseInt(daysAndHours[1]);
                mins = parseInt(timeSpanParts[1]);
            } else {
                // no days
                hours = parseInt(timeSpanParts[0]);
                mins = parseInt(timeSpanParts[1]);
            }
        }
        return {
            Days: days,
            Hours: hours,
            Minutes: mins
        };
    }

    isLoading.promise(octopusRepository.Subscriptions.all().then(function(subscriptions) {
        isLoading.promise(octopusRepository.Teams.all().then(function(teams) {
            _.each(subscriptions, function (subscription) {

                // Emails
                var emailFrequencyPeriod = parseTimeSpan(subscription.EventNotificationSubscription.EmailFrequencyPeriod);
                if (emailFrequencyPeriod) {
                    var emailFrequencyPeriodText = 'Send email notifications every';
                    if (emailFrequencyPeriod.Days > 0) {
                        emailFrequencyPeriodText += ' ' + emailFrequencyPeriod.Days + ' day' + (emailFrequencyPeriod.Days === 1 ? '' : 's');
                    }
                    if (emailFrequencyPeriod.Hours > 0) {
                        emailFrequencyPeriodText += ' ' + emailFrequencyPeriod.Hours + ' hour' + (emailFrequencyPeriod.Hours === 1 ? '' : 's');
                    }
                    if (emailFrequencyPeriod.Minutes > 0 || emailFrequencyPeriod.Hours === 0) {
                        emailFrequencyPeriodText += ' ' + emailFrequencyPeriod.Minutes + ' minute' + (emailFrequencyPeriod.Minutes === 1 ? '' : 's');
                    }
                    subscription.emailFrequencyPeriodText = emailFrequencyPeriodText;
                }
                subscription.emailTeams = getTags(subscription.EventNotificationSubscription.EmailTeams, teams);

                // Webhooks
                subscription.webhookTeams = getTags(subscription.EventNotificationSubscription.WebhookTeams, teams);

            });
            $scope.subscriptions = subscriptions;
        }));
    }));

    var getTags = function(allOptions, selectedOptions) {
        if (allOptions.length === 0) {
            return "";
        }
        var result = [];
        _.each(selectedOptions, function (e) {
            if (allOptions.indexOf(e.Id) >= 0) {
                result.push(e.Name);
            }
        });
        return result.join(",");
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/subscriptions/controllers/subscriptions_controller.js
// module id = 3416703266734615
// module chunks = 1